import { FlightService } from './../../flights/flight.service';
import { AuthService } from './../../auth/auth.service';
import { TicketService } from './../ticket.service';
import { IFlight } from './../../flights/flight';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControlName,
  AbstractControl
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, ElementRef } from '@angular/core';
import { GenericValidator } from '../../shared/generic-validator';
import {
  Helper,
  COUNTRIES,
  TICKET_STATUSES,
  DateValidator
} from '../../shared/helper';
import { ITicket } from '../ticket';

@Component({
  selector: 'app-create-ticket',
  templateUrl: './create-ticket.component.html',
  styleUrls: ['./create-ticket.component.css']
})
export class CreateTicketComponent implements OnInit, OnDestroy, AfterViewInit {
  firstStepForm: FormGroup;
  firstStepError: any;
  secondStepForm: FormGroup;
  secondStepFormStatus = false;
  asincFromDataResolve: any;
  disableForm = true;
  holdTicketInterval = null;
  countries = COUNTRIES;
  displayMessages: any = {};
  @ViewChildren(FormControlName, { read: ElementRef })
  formInputElements: ElementRef[];
  private genericValidator: GenericValidator;
  action = 'Create';
  ticketFormIndex = -1;
  TICKET_STATUSES = TICKET_STATUSES;
  ticketId = 0;
  ticketHoldIds = [];
  passIndex = 0;
  changeFlight = false;
  ticket: ITicket;

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private ticketService: TicketService,
    private flightService: FlightService,
    private helper: Helper,
    private authService: AuthService
  ) {}
  get flights() {
    return <IFlight[]>this.firstStepForm.controls.flights.value;
  }

  get passengerDetails() {
    return <FormArray>this.secondStepForm.controls.passengerDetails;
  }

  get ticketDetails() {
    return <FormArray>this.secondStepForm.controls.ticketDetails;
  }

  getTicketFormIndex(): number {
    if (this.ticketDetails.controls.length > this.ticketFormIndex) {
      this.ticketFormIndex++;
      return this.ticketFormIndex;
    }
  }

  ngOnInit() {
    console.log(this.authService.getUser());
  }

  initFirstStepForm(flights: IFlight[]) {
    this.firstStepForm = this.fb.group({
      ticket_status: ['sold', Validators.required],
      adult_number: [null, [Validators.min(0)]],
      infant_number: [0, [Validators.required, Validators.min(0)]],
      flights: [flights, Validators.required]
    });
    this.disableForm = false;
  }

  ngOnDestroy() {
    clearInterval(this.holdTicketInterval);
  }

  ngAfterViewInit(): void {}

  initSecondStepForm(adultAmount: number, infantAmount: number) {
    this.passIndex = 0;
    this.secondStepForm = this.fb.group({
      passengerDetails: this.fb.array([], Validators.required),
      ticketDetails: this.fb.array([], Validators.required)
    });
    if (adultAmount) {
      this.createPassDetailsAndFlights(adultAmount, 'Adult');
    }
    if (infantAmount) {
      this.createPassDetailsAndFlights(infantAmount, 'Infant');
    }
    this.secondStepForm.valueChanges.subscribe(val => {
      console.log(this.secondStepForm.value);
    });

    this.secondStepFormStatus = true;
  }

  createPassDetailsAndFlights(amount, type) {
    const flightDates = this.flights.map(fl => fl.flightDateTime);
    for (let i = 0; i < amount; i++) {
      this.passengerDetails.push(this.passengerControls(type, flightDates));
      this.flights.forEach(fl => {
        this.ticketDetails.push(this.ticketControls(fl, this.passIndex));
      });
      this.passIndex++;
    }
  }

  onPassengerDobChange(e, i) {
    const val = e.target.value;
    const passDob: AbstractControl = this.passengerDetails.controls[i].get(
      'passengerDob'
    );
    const formattedDate = this.helper.autoDateFormat(val);
    // console.log(formattedDate);
    passDob.setValue(formattedDate);
    this.setTicketPrice(val, i);
  }

  passengerControls(type: string, flightDates: string[]) {
    const pattern = /^\d{2}-\d{2}-\d{4}$/;
    return this.fb.group({
      passengerType: [type, Validators.required],
      passengerFirstName: ['', Validators.required],
      passengerLastName: ['', Validators.required],
      passengerCitizenship: ['Georgia', Validators.required],
      passengerGovId: ['', Validators.required],
      passengerSex: ['male'],
      passengerDob: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(pattern),
          DateValidator.infuntDate(flightDates, type)
        ])
      ],
      passengerEmail: ['', [Validators.required, Validators.email]],
      passengerContacts: ['', Validators.required]
    });
  }

  ticketControls(flight: IFlight, i: number) {
    return this.fb.group({
      ticketPrice: [0, [Validators.required, Validators.min(0)]],
      ticketNotes: [''],
      ticketIssuer: [
        `/users/` + this.authService.getUser()['id'],
        Validators.required
      ],
      ticketNumber: [Math.random().toString()],
      ticketCreated: ['2002-02-28T11:11:00+04:00'],
      ticketUpdated: ['2002-02-28T11:11:00+04:00'],
      ticketStatus: [this.firstStepForm.controls.ticket_status.value],
      ticketFlight: [`/flights/${flight.id}`, Validators.required],
      flight: [flight],
      passengerIndex: [i],
      guardianTicket: [0]
    });
  }

  onDeletePassenger(i: number) {
    if (confirm('Do you want to delete passenger')) {
      this.passengerDetails.removeAt(i);
      if (this.deleteTicket(i)) {
        console.log(this.secondStepForm.value);
        console.warn('pass deleted');
        this.reIndexTicketPassenger();
        console.log(this.secondStepForm.value);
      }
    }
  }

  deleteTicket(i: number) {
    const tkDetails = this.ticketDetails.value;
    for (let k = 0; k < tkDetails.length; k++) {
      const tk = tkDetails[k];
      if (tk.passengerIndex === i) {
        this.ticketDetails.removeAt(k);
        console.log('deleting>>', k, tk);
        this.deleteTicket(i);
        break;
      }
    }
    return true;
  }

  reIndexTicketPassenger() {
    const flI = this.flights.length;
    let countI = 0;
    this.ticketDetails.controls.forEach((tk, i) => {
      tk.get('passengerIndex').setValue(countI);
      if ((i + 1) % flI === 0) {
        countI++;
      }
    });
  }

  setTicketPrice(passengerDob: any, index: number) {
    const flightDate = this.flights[0].flightDateTime;
    const passengerAge = this.helper.getPersonAge(passengerDob, flightDate);
    console.log(passengerAge);
    let priceName: string;
    if (passengerAge >= 12) {
      priceName = 'priceFull';
    } else if (passengerAge >= 3) {
      priceName = 'priceChild';
    } else {
      priceName = 'priceInfant';
    }
    // console.log('ticketDetails.value>', this.ticketDetails.value);
    this.ticketDetails.value.forEach((el, i) => {
      const ticket = this.ticketDetails.controls[i];
      const flight = ticket.get('flight').value;
      const ticketPrice = flight[priceName];
      if (el.passengerIndex === index) {
        ticket.get('ticketPrice').setValue(ticketPrice);
      }
    });
  }

  secondStep() {
    this.disableForm = true;
    // this.checkTicket();
    this.holdTicket();
  }

  holdTicket() {
    const adultAmount = this.firstStepForm.controls.adult_number.value;
    const infantAmount = this.firstStepForm.controls.infant_number.value;
    this.ticketHoldIds = [];
    this.firstStepError = '';
    this.flights.forEach((fl, i) => {
      this.ticketService.holdTicket(fl.id, adultAmount, infantAmount).subscribe(
        res => {
          const holdRequestDone = i + 1 === this.flights.length;
          if (res.success) {
            this.ticketHoldIds.push(res.hold_id);
            if (holdRequestDone) {
              this.initSecondStepForm(adultAmount, infantAmount);
              this.continueHolding(this.ticketHoldIds);
            }
          }
          if (holdRequestDone) {
            this.disableForm = false;
          }
        },
        error => {
          this.disableForm = false;
          this.firstStepError = error.message;
        }
      );
    });
  }

  checkTicket() {
    this.flights.forEach(fl => {
      this.ticketService.checkTicket(fl.id).subscribe(res => {});
    });
  }

  continueHolding(holdIds?: number[]) {
    this.holdTicketInterval = setInterval(() => {
      holdIds.forEach(id => {
        this.ticketService.holdTicket(id).subscribe(res => {});
      });
    }, 5000);
  }

  createTicketData(ticket: any) {
    const i = ticket.passengerIndex;
    const passengerDetails = this.passengerDetails.controls[i].value;
    console.log('>>', passengerDetails.passengerDob);
    passengerDetails.passengerDob = this.helper.formatStringToDate(
      passengerDetails.passengerDob
    );
    console.log('>>', passengerDetails.passengerDob);

    const data = { ...ticket, ...passengerDetails };
    // console.log(data);
    return data;
  }

  saveTicket(print = false) {
    this.disableForm = true;
    const ticketDetails = this.secondStepForm.value.ticketDetails;
    if (this.action === 'Create') {
      let count = 0;
      const ticketIds: number[] = [];
      ticketDetails.forEach(ticket => {
        const data = this.createTicketData(ticket);
        this.ticketService.createTicket(data).subscribe(
          res => {
            count++;
            ticketIds.push(res.id);
            this.ticketService.deleteTicketHold(res.id);
            console.warn(ticketDetails.length, count);
            if (ticketDetails.length === count) {
              this.ticketHoldIds.forEach(id => {
                this.ticketService.deleteTicketHold(id).subscribe(() => {});
              });
              this.activeModal.close(res);

              if (print === true) {
                const ids = ticketIds.join(',');
                window.open('/tickets/print/en/' + ids);
              }
            }
          },
          error => {
            this.disableForm = false;
            alert(JSON.stringify(error));
          }
        );
      });
    } else {
      const data = this.createTicketData(ticketDetails[0]);
      data.id = this.ticketId;
      this.ticketService.updateTicket(data).subscribe(
        res => {
          this.activeModal.close(res);
          if (print === true) {
            window.open('/tickets/print/en/' + this.ticketId);
          }
        },
        error => {
          this.disableForm = false;
          alert(JSON.stringify(error));
        }
      );
    }
  }

  patchTicketDetails(ticket: ITicket) {
    this.secondStepForm.patchValue({
      passengerDetails: [
        {
          passengerFirstName: ticket.passengerFirstName,
          passengerLastName: ticket.passengerLastName,
          passengerCitizenship: ticket.passengerCitizenship,
          passengerGovId: ticket.passengerGovId,
          passengerSex: ticket.passengerSex,
          passengerEmail: ticket.passengerEmail,
          passengerDob: this.helper.getTicketPersonDate(ticket.passengerDob),
          passengerContacts: ticket.passengerContacts
        }
      ],
      ticketDetails: [
        {
          ticketPrice: ticket.ticketPrice,
          ticketNotes: ticket.ticketNotes,
          ticketIssuer: '/users/' + ticket.ticketIssuer.id,
          ticketNumber: ticket.ticketNumber,
          ticketCreated: ticket.ticketCreated,
          ticketUpdated: '2002-02-28T11:11:00+04:00',
          ticketStatus: ticket.ticketStatus,
          ticketFlight: '/flights/' + ticket.ticketFlight.id,
          guardianTicket: 0
        }
      ]
    });
  }

  editFormInit(ticket: ITicket, flight?: IFlight) {
    this.action = 'Edit';
    this.ticket = ticket;
    const fl = flight || ticket.ticketFlight;
    this.ticketId = ticket.id;
    console.log(fl);
    this.initFirstStepForm([fl]);
    this.initSecondStepForm(1, 0);
    this.patchTicketDetails(ticket);
    console.log(ticket);
  }

  closeActiveModal() {
    if (this.firstStepForm.dirty) {
      if (confirm(`Are you sure to close form?`)) {
        this.activeModal.dismiss();
      }
    } else {
      this.activeModal.dismiss();
    }
  }

  saveAndPrint() {
    this.saveTicket(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/tickets/create/create-ticket.component.ts